import { useCallback, useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import config from '../config';
import { UserContext } from '../components/MyContext';

import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppShell from '../components/AppShell';
import YearEntryCard from '../components/YearEntryCard';

import { IoFilterSharp } from "react-icons/io5";
import { FaCloudUploadAlt, FaTint } from 'react-icons/fa';

export default function Activitydata() {
    const { userData } = useContext(UserContext);
    const [dataPeriods, setDataPeriods] = useState([]);
    const [periodStatuses, setPeriodStatuses] = useState({});
    const [searchYear, setSearchYear] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;

    const fetchDataPeriod = useCallback(async () => {
        try {
            const res = await axios.get(`${config.urlApi}/activity/showPeriod/${userData.facultyID}`);
            setDataPeriods(res.data);
        } catch (e) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: e.message
            });
        }
    }, [userData.facultyID]);

    useEffect(() => {
        if (userData.facultyID) {
            fetchDataPeriod();
        }
    }, [fetchDataPeriod, userData.facultyID]);

    useEffect(() => {
        if (dataPeriods.length === 0) return;

        const fetchPeriodStatuses = async () => {
            try {
                const entries = await Promise.all(
                    dataPeriods.map(async (item) => {
                        try {
                            const res = await axios.get(`${config.urlApi}/scope/datasocpe/${item.id}`);
                            const hasSavedData = Array.isArray(res.data) && res.data.some((scope) =>
                                Array.isArray(scope.headcategories) && scope.headcategories.some((headCategory) =>
                                    Array.isArray(headCategory.data_scopes) && headCategory.data_scopes.some((dataScope) =>
                                        dataScope.quantity !== null &&
                                        dataScope.quantity !== undefined &&
                                        `${dataScope.quantity}`.trim() !== ''
                                    )
                                )
                            );

                            return [item.id, hasSavedData ? 'success' : 'pending'];
                        } catch {
                            return [item.id, 'pending'];
                        }
                    })
                );

                setPeriodStatuses(Object.fromEntries(entries));
            } catch {
                setPeriodStatuses({});
            }
        };

        fetchPeriodStatuses();
    }, [dataPeriods]);

    const handleSearchChange = (selectedOption) => {
        setSearchYear(selectedOption ? selectedOption.value : '');
    };

    const handleClickPage = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const filteredData = dataPeriods.filter(item => {
        if (!searchYear) return true;
        return item.years + 543 === parseInt(searchYear);
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    // Create options for years from dataPeriods
    const yearOptions = dataPeriods.map(item => ({
        value: item.years + 543,
        label: item.years + 543
    }));

    const filterActions = (
        <div className="app-filter-bar">
            <IoFilterSharp className='me-2' size={25} />
            <Select
                classNamePrefix="react-select"
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="fixed"
                options={yearOptions}
                onChange={handleSearchChange}
                isClearable
                placeholder={`เลือกปี..`}
                theme={(theme) => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary25: '#d6f2eb',
                        primary: '#0f766e',
                    },
                })}
                styles={{
                    control: (base) => ({
                        ...base,
                        borderRadius: '16px',
                        padding: '0.1rem 0.5rem',
                        color: 'black',
                        width: '300px',
                        fontSize: '0.94rem',
                        cursor: 'pointer',
                        borderColor: 'rgba(148, 163, 184, 0.28)',
                        boxShadow: 'none',
                    }),
                    valueContainer: (base) => ({
                        ...base,
                        fontSize: '0.94rem',
                    }),
                    placeholder: (base) => ({
                        ...base,
                        fontSize: '0.92rem',
                    }),
                    singleValue: (base) => ({
                        ...base,
                        fontSize: '0.94rem',
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                    menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                    option: (base) => ({
                        ...base,
                        fontSize: '0.94rem',
                    })
                }}
            />
        </div>
    );

    return (
        <AppShell
            page="activityDate"
            contentPreset="dashboard"
            title={userData.campusID === 'CT' ? 'โรงบำบัดน้ำเสีย' : 'กรอกข้อมูลก๊าซเรือนกระจก'}
            subtitle={userData.campusID === 'CT' ? 'เลือกปีงบประมาณเพื่อเข้าไปจัดการข้อมูลโรงบำบัดน้ำเสียของหน่วยงาน' : `เลือกปีข้อมูลกิจกรรมของวิทยาเขต ${userData.campusName || '-'} หน่วยงาน ${userData.facultyName || '-'}`}
            actions={filterActions}
        >
            <section className="section">
                {currentItems.length > 0 ? (
                    <div className="app-year-grid">
                        {currentItems.map((item) => (
                            <div className="app-year-grid__item" key={item.id}>
                                <YearEntryCard
                                    to={userData.campusID === 'CT'
                                        ? `/watertreatmentplants/${item.campus_id}/${item.fac_id}/${item.years + 543}/${item.id}`
                                        : `/activityDetail/${item.campus_id}/${item.fac_id}/${item.years + 543}/${item.id}`
                                    }
                                    year={item.years + 543}
                                    tone={userData.campusID === 'CT' ? 'sky' : 'teal'}
                                    badge={userData.campusID === 'CT' ? 'Water Treatment Entry' : 'Greenhouse Gas Entry'}
                                    icon={userData.campusID === 'CT' ? <FaTint /> : <FaCloudUploadAlt />}
                                    logoSrc={userData.logo ? `${config.urlApi}/logos/${userData.logo}` : ''}
                                    logoAlt="faculty logo"
                                    title={userData.campusID === 'CT' ? `บันทึกข้อมูลโรงบำบัด ปี ${item.years + 543}` : `กรอกข้อมูลก๊าซเรือนกระจก ปี ${item.years + 543}`}
                                    description={userData.campusID === 'CT'
                                        ? 'เข้าสู่แบบฟอร์มบันทึกข้อมูลกิจกรรมโรงบำบัดน้ำเสียรายปี พร้อมตรวจสอบรายการที่ต้องกรอกในรอบปีนี้'
                                        : `เข้าสู่แบบฟอร์มบันทึกกิจกรรมการปล่อยก๊าซเรือนกระจกของวิทยาเขต ${userData.campusName || '-'} และหน่วยงาน ${userData.facultyName || '-'}`}
                                    meta={[
                                        userData.campusName || 'ไม่ระบุวิทยาเขต',
                                        userData.facultyName || 'ไม่ระบุหน่วยงาน'
                                    ]}
                                    status={periodStatuses[item.id] === 'success' ? 'success' : 'pending'}
                                    statusLabel={periodStatuses[item.id] === 'success' ? 'บันทึกสำเร็จ' : 'ยังไม่ได้บันทึก'}
                                    actionLabel={userData.campusID === 'CT' ? 'เปิดแบบฟอร์มโรงบำบัด' : 'เปิดแบบฟอร์มกิจกรรม'}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="app-empty-state app-empty-state--top app-empty-state--content app-empty-state--year-entry">
                        <div className="app-empty-state__badge">{searchYear ? 'ไม่พบปีที่ค้นหา' : 'ยังไม่มีรอบปีให้ลงข้อมูล'}</div>
                        <h3 className="app-empty-state__title">{searchYear ? `ยังไม่พบรอบปี พ.ศ. ${searchYear} ในส่วนนี้` : 'ยังไม่มีรอบปีสำหรับบันทึกข้อมูลในหน้านี้'}</h3>
                        <p className="app-empty-state__description">
                            {searchYear
                                ? 'ลองเปลี่ยนปีที่ค้นหา หรือล้างตัวกรองเพื่อดูรอบปีอื่นที่เปิดให้กรอกข้อมูล'
                                : 'เมื่อระบบสร้างรอบปีสำหรับหน่วยงานแล้ว การ์ดลงข้อมูลของแต่ละปีจะปรากฏที่หน้านี้โดยอัตโนมัติ'}
                        </p>
                    </div>
                )}
            </section>

            <nav>
                <ul className="pagination justify-content-center">
                    {[...Array(totalPages)].map((_, i) => (
                        <li key={i + 1} className={`page-item ${i + 1 === currentPage ? 'active' : ''}`}>
                            <button
                                className="page-link px-3"
                                onClick={() => handleClickPage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </AppShell>
    );
}
